import React from "react";
import styled from "styled-components";

const Template = ({ label, picture }) => (
  <div
    style={{
      alignItems: 'center',
      display: 'flex',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
    }}
  >
    {picture && (
      <img
        style={{
          height: '24px',
          width: '24px',
          borderRadius: '50%',
          marginRight: '8px',
        }}
        src={picture}
        // No alt text as user's name adjacent to the profile pic is sufficient. 
      />
    )}
    <span>{label}</span>
  </div>
)

export default styled(Template)``;
